import request from 'utils/request'

const DEFAULT_STRINGS = require('../strings/en.json')

// ------------------------------------
// Constants
// ------------------------------------

const SET_STRINGS = 'SET_STRINGS'

const DEFAULT_LANGUAGE = 'en'

// ------------------------------------
// Actions
// ------------------------------------

const setStrings = payload => {
  return {
    type: SET_STRINGS,
    payload,
  }
}

// ------------------------------------
// Utils
// ------------------------------------

const getStringValues = strings => {
  const keys = Object.keys(strings)
  const output = {}
  keys.forEach(key => {
    output[key] = strings[key].v
  })
  return output
}

//
// Parses locale to language parameter used by Applanga
// ex) 'en_US' to 'en'
//
const parseLocale = locale => {
  if (locale.includes('_')) {
    return locale.split('_')[0]
  }
  return locale
}

// ------------------------------------
// Action Creators
// ------------------------------------

const onFetchApplangaStrings = (language = DEFAULT_LANGUAGE) => {
  return dispatch => {
    const { APPLANGA_AUTHORIZATION_HEADER } = process.env
    const appId = APPLANGA_AUTHORIZATION_HEADER
      ? APPLANGA_AUTHORIZATION_HEADER.split('!')[0]
      : ''
    if (!appId) {
      dispatch(setStrings(DEFAULT_STRINGS))
      return
    }
    let langaugeParam = language
    if (language !== DEFAULT_LANGUAGE) {
      langaugeParam = parseLocale(language)
    }
    dispatch(
      request({
        method: 'GET',
        url: `https://api.applanga.com/v1/api?app=${appId}&requestedGroups=[%22main%22]&requestedLanguages=[%22${langaugeParam}%22]`,
        headerOptions: {
          Authorization: `Bearer ${APPLANGA_AUTHORIZATION_HEADER}`,
        },
        authRequired: false,
        success: json => {
          const strings = getStringValues(json.data[langaugeParam].main.entries)
          const isResponseEmpty = !Object.values(strings)[0]
          const finalStrings = isResponseEmpty ? DEFAULT_STRINGS : strings
          dispatch(setStrings(finalStrings))
        },
      }),
    )
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const stringKeys = Object.keys(DEFAULT_STRINGS)
const initialState = {}
stringKeys.forEach(key => {
  initialState[key] = ''
})

const stringsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STRINGS: {
      return action.payload || DEFAULT_STRINGS
    }
    default:
      return state
  }
}

export const stringsActions = {
  onFetchApplangaStrings,
}

export default stringsReducer



// WEBPACK FOOTER //
// ./src/store/strings.js